import { render } from "./LanguageListComponent.vue?vue&type=template&id=961829b6"
import script from "./LanguageListComponent.vue?vue&type=script&lang=js"
export * from "./LanguageListComponent.vue?vue&type=script&lang=js"

import "./LanguageListComponent.vue?vue&type=style&index=0&id=961829b6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__